export default __webpack_public_path__ + "static/lettuce-ddbc15084b7fd331b6ef5c88b3ff6c12.jpg";